import { quoteLineType } from '../../types'
import { CarahsoftPriceListItem } from './carahsoftTypes'

export function carahsoftItemToLineItem(
  lineNumber: number,
  _mfgPN: string,
  item: CarahsoftPriceListItem,
): Partial<quoteLineType> {
  return {
    LineItemId: crypto.randomUUID(),
    LineNumber: lineNumber,
    Bundle: null,
    Provider: 'Carahsoft',
    Manufacturer: item.vendor,
    MfrPartNumber: item.vendorPartNumber,
    VendorPartNumber: item.carahsoftPartNumber,
    Description: item.description,
    Qty: 1,
    UnitCost: item.contractPrice,
    MSRP: item.listPrice,
    CountryOfOrigin: item.countryOfOrigin,
    // TAA, EnergyStar, EPEAT, UNSPSC intentionally omitted —
    // not present in Carahsoft's PriceList API; normalize later if needed.
  }
}
